import envHelper from './environment/env-helper';

const envObj=envHelper.setEnvironmentURLs(window && window.location && window.location.hostname);

export const SERVER = {
    API_BASE_URL: envObj.API_BASE_URL,
    OIDC_REDIRECT_URI : envObj.REDIRECT_URL,
    PLANON_URL : envObj.PLANON_URL,
    SERVICES: {
        //Businesspartner url
        getAssetDetails: "/assets/",
        getSpaceDetails:"/spaces/",
        submitIncident:"/Incident",
        GENERATE_TOKEN: '/authorization/token/',
        updateEmail:"/requestor/",
        REFRESH_TOKEN:"/authorization/token/getrefreshtoken/",
        FMS_SESSION_TRACK : "/session/tracking",
        FMS_VERIFY_EMAIL : "/verifyEmail",
        FMS_RESEND_VERIFY_LINK : "/resendLink",
        QR_SESSION_ID : "/qrsession",
        QR_AUTHORIZATION : "/authorization/token/qr",
        GENERATE_ENTRA_TOKEN : "/authorization/token/entra",
    }
}
